import React from 'react';

export default function Monitor(props) {
  return (
    <p>ICC Administrative App</p>
  );
}